module.exports = __webpack_public_path__ + "img/img_mainland_account_open_5.5865f0b5.png";